import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import ParityManagerFiltersMarketInfo from 'lumen/models/parity-manager/filters/market-info';
import type { IssueType } from 'lumen/utils/constants/pi-constant-values';

export default class ParityManagerFiltersRootCause extends ParityManagerFiltersMarketInfo {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-manager/filters/root-cause' as const;

  @attr('number') declare issueType: IssueType;
  @attr('string') declare name: string;
}
